import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color, trend }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    yellow: 'bg-yellow-50 text-yellow-600',
    red: 'bg-red-50 text-red-600',
    purple: 'bg-purple-50 text-purple-600',
    gray: 'bg-gray-50 text-gray-600'
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 transition-shadow hover:shadow-md">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-500">{title}</h3>
        <div className={`p-2 rounded-lg ${colorClasses[color] || colorClasses.gray}`}>
          <Icon size={20} />
        </div>
      </div>
      <div className="flex items-baseline">
        <h2 className="text-2xl font-bold text-gray-900">{value}</h2>
        {trend && (
            <span className={`ml-2 flex items-center text-xs font-medium ${
                trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-500'
            }`}>
                {trend > 0 ? <ArrowUp size={12} className="mr-1"/> : trend < 0 ? <ArrowDown size={12} className="mr-1"/> : <Minus size={12} className="mr-1"/>}
                {Math.abs(trend)}%
            </span>
        )}
      </div>
    </div>
  );
};

export default StatCard;

